import { Stack, Typography } from '@prenuvo/halo';

import { useAddendum } from '@/core/addendum';
import { useIsDDFeatureFlagEnabled } from '@/core/data-dog';
import { useStudyModeStore } from '@/store';

export function StudyModeIndicator() {
  const isAddendumEnabled = useIsDDFeatureFlagEnabled('FCT_ADDENDUM');
  const studyMode = useStudyModeStore((state) => state.studyMode);
  const { activeSession } = useAddendum();

  const hasActiveSession = activeSession?.status === 'active';

  const show = {
    indicator: isAddendumEnabled && (studyMode !== null || hasActiveSession),
  };

  if (show.indicator) {
    return (
      <Stack alignment="center">
        <div className="size-2 animate-pulse rounded-full bg-orange-500" />
        <Typography
          className="text-neutral-300"
          translationKey={
            studyMode === 'read-only'
              ? 'FCT.ADDENDUM.STUDY_MODE.READ_ONLY'
              : 'FCT.ADDENDUM.STUDY_MODE.ADDENDUM'
          }
          variant="paragraph-sm"
        />
      </Stack>
    );
  }

  return null;
}
